// extracted by mini-css-extract-plugin
export default {"description":"ScheduleDescription_description__rNDar"};